var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Styled } from './style';
var AppBlogCard = /** @class */ (function (_super) {
    __extends(AppBlogCard, _super);
    function AppBlogCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppBlogCard.prototype.render = function () {
        return (React.createElement(Styled, { title: this.props.name },
            React.createElement("a", { className: "content", href: this.props.url, rel: "noreferrer", target: "_blank" },
                React.createElement("h3", { className: "title" }, this.props.name),
                React.createElement("p", { className: "category" }, this.props.category)),
            React.createElement("div", { className: "cover", style: { background: "url(" + this.props.image + ") no-repeat", backgroundSize: "cover" } })));
    };
    return AppBlogCard;
}(React.Component));
export default AppBlogCard;
//# sourceMappingURL=index.js.map